// Reusable romantic header for dashboard tabs: a delicate sprig ornament, the
// title, a warm human subtitle, and a personalized "X days to forever" tag.
// Replaces the bare serif titles so every working screen opens with feeling.
import { useWedding } from '../context/WeddingContext'
import { Sprig } from './ornaments'
import { countdownTag } from '../lib/loveNotes'

export default function PageHeader({ title, subtitle, tag = true, right, children }) {
  const { wedding } = useWedding()
  const micro = tag ? countdownTag(wedding) : null

  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '1rem', flexWrap: 'wrap', marginBottom: '1.5rem' }}>
      <div style={{ minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.55rem', marginBottom: '0.3rem' }}>
          <Sprig size={22} />
          <h1 style={{ fontFamily: 'Gibs, serif', fontWeight: 400, fontSize: 'clamp(1.5rem,3vw,1.9rem)', color: '#1A1A1A', margin: 0, letterSpacing: '-0.02em' }}>{title}</h1>
        </div>
        {subtitle && <p style={{ fontFamily: 'Nunito Sans, sans-serif', fontSize: '0.9rem', color: '#6B6B6B', margin: '0 0 0.35rem', lineHeight: 1.6 }}>{subtitle}</p>}
        {micro && (
          <p style={{ fontFamily: 'Nunito Sans, sans-serif', fontSize: '0.72rem', fontWeight: 700, color: '#C4826A', letterSpacing: '0.03em', margin: 0 }}>
            {micro}
          </p>
        )}
        {children}
      </div>
      {right && <div style={{ flexShrink: 0 }}>{right}</div>}
    </div>
  )
}
